"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var PLUSGIRO_REGEXP = /^\d{1,7}-\d{1}$/;
exports.plusgiroValidator = {
    name: 'plusgiro',
    formatter: function (value) {
        /**
         * Add spaces between each pair of digits before the hyphen back-to-front.
         * If the number of digits is odd then the first pair in the string can be a single digit.
         * If the number of characters is 9, there will be a space after the first 3 characters.
         */
        value = value.replace(/ /g, '');
        var startOffset = 4;
        var formattedString = value.substring(value.length - startOffset, value.length);
        var step = 2;
        for (var i = value.length - startOffset; i >= (value.length === 9 ? 3 : 1); i -= step) {
            formattedString = value.substring(Math.max(i - step, 0), i) + ' ' + formattedString;
        }
        if (value.length === 9) {
            formattedString = value.substring(0, 1) + formattedString;
        }
        return formattedString;
    },
    validation: function (value) {
        if (utils_1.isEmpty(value))
            return true;
        value = value.replace(/ /g, '');
        return PLUSGIRO_REGEXP.test(value) && utils_1.testLuhnChecksum(value.replace(/\D/g, ''));
    },
};
//# sourceMappingURL=PlusgiroValidator.js.map